import { api } from '../services/api';
import type { CreatePlacementRequest, Placement } from '../types';

/**
 * Create a placement with a readable share code ("bio", "bio-2", …), falling
 * back to a random code when those are taken. Codes are unique per company.
 */
export async function createPlacementWithCode(
  experimentId: string,
  request: Omit<Extract<CreatePlacementRequest, { kind: 'link' | 'partner' }>, 'shareCode'>,
  preferredCode?: string
): Promise<Placement> {
  const candidates = preferredCode
    ? [preferredCode, `${preferredCode}-2`, `${preferredCode}-3`]
    : [];
  for (const shareCode of candidates) {
    try {
      return await api.createPlacement(experimentId, { ...request, shareCode });
    } catch (err) {
      // 409 "already taken" → try the next code; anything else is real.
      if (!(err instanceof Error) || !/taken/i.test(err.message)) throw err;
    }
  }
  return api.createPlacement(experimentId, request);
}
